import React, { useEffect, useState } from "react";
import { Card, Spin, Alert, Form, InputNumber, Button, message } from "antd";
import useGetRequest from "../../hooks/useGetRequest";
import { api } from "../../api/api";

export default function TurnoverSettingsPage() {
  const { data, loading, error, refresh } = useGetRequest(
    "/settings/turnover-exchange-rate"
  );
  const [rate, setRate] = useState<number | undefined>(undefined);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (data?.turnoverExchangeRate !== undefined) {
      setRate(data.turnoverExchangeRate);
    }
  }, [data]);

  const onSave = async () => {
    if (!rate || rate <= 0) {
      message.error("Введите корректный курс > 0");
      return;
    }
    try {
      setSaving(true);
      await api.post("/settings/turnover-exchange-rate", {
        turnoverExchangeRate: rate,
      });
      message.success("Курс для оборота обновлён");
      refresh();
    } catch (e) {
      message.error("Не удалось сохранить");
    } finally {
      setSaving(false);
    }
  };

  if (error) {
    return <Alert message="Ошибка загрузки" type="error" showIcon />;
  }
  if (loading) {
    return <Spin tip="Загрузка..." />;
  }

  return (
    <Card title="Курс для расчёта оборота" style={{ maxWidth: 480 }}>
      <Form layout="vertical" onFinish={onSave} initialValues={{ rate }}>
        <Form.Item label="Курс (USD)" required>
          <InputNumber
            value={rate}
            onChange={(v) => setRate(v as number)}
            min={0}
            step={0.0001}
            style={{ width: "100%" }}
          />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={saving}>
          Сохранить
        </Button>
      </Form>
    </Card>
  );
}


